import { cartDetailsFragment } from '../queries/get-cart-query'

/**
 * @see https://shopify.dev/docs/api/storefront/2024-10/mutations/cartGiftCardCodesUpdate
 */
const cartGiftCardCodesUpdateMutation = /* GraphQL */ `
	mutation cartGiftCardCodesUpdate($cartId: ID!, $giftCardCodes: [String!]!) {
		cartGiftCardCodesUpdate(cartId: $cartId, giftCardCodes: $giftCardCodes) {
			cart {
				...cartDetails
			}
			userErrors {
				code
				field
				message
			}
			warnings {
				code
				message
			}
		}
	}

	${cartDetailsFragment}
`

export default cartGiftCardCodesUpdateMutation
